// Reusable form section component with standardized section heading
// Provides consistent styling for form sections across modals and forms
// CREATED: Typography standardization - section headings in forms

import { TYPOGRAPHY } from '../../lib/designSystem';

interface FormSectionProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  spacing?: 'default' | 'compact' | 'relaxed';
}

export function FormSection({
  title,
  children,
  className = '',
  spacing = 'default'
}: FormSectionProps) {
  const spacingClasses = {
    compact: 'mb-4 pb-4',
    default: 'mb-6 pb-6',
    relaxed: 'mb-8 pb-8'
  };

  return (
    <div className={`${spacingClasses[spacing]} border-b border-gray-200 last:border-b-0 last:mb-0 last:pb-0 ${className}`}>
      <h3 className={`${TYPOGRAPHY.sectionHeading} mb-4`}>
        {title}
      </h3>
      {children}
    </div>
  );
}
